<template>
  <div>
    <b-row>
      <b-col md='4'>
        <b-card title="Documento de usuario a buscar" id="qr_entrega" class="text-uppercase text-center">
          <b-btn variant='success' @click='show_qr = true'>Preparar</b-btn>
          <qrcode-reader v-if="show_qr" @decode="onDecode" style="width:100%"></qrcode-reader>
        </b-card>
      </b-col>
      <b-col style='position:relative;height:450px;overflow-y:auto'>
        <b-card v-for="(pedido,index) in pedidos" :key='pedido.index' :title="pedido.name+' - '+pedido.code" class="text-uppercase">
          <b-row>
            <b-col v-for='(ped,index_ped) in pedido.pedidos' :key='ped.id' md='6'>
              <b-card>
                <b-row>
                  <b-col md="2">
                    <h1 v-if="ped.turn.length < 3" >{{ped.turn}}</h1>
                    <h4 v-if="ped.turn.length > 2" >{{ped.turn}}</h4>
                  </b-col>
                  <b-col>
                    <b-row>
                      <b-col md='10'>
                        <p>{{ped.products}}</p>
                        <p>{{ped.comment}}</p>
                      </b-col>
                      <b-col>
                        <b-btn v-if='!ped.preparado' variant='success' size='lg' @click="prepare_request(pedido.code,ped)">
                          <i class="fa fa-check"></i>
                        </b-btn>
                        <b-btn v-if='ped.preparado' variant='danger' size='lg' @click="remove_item_request(index,index_ped)">
                          <i class="fa fa-times"></i>
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-btn variant='success' block @click="dispatch_request(index)">Entregar</b-btn>
            </b-col>
            <b-col>
              <b-btn variant='danger' block @click="remove_request(index)">Cancelar</b-btn>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "validate",
  data: function() {
    return {
      selected: null,
      idSearch: "",
      user: "",
      show_qr: false,
      aux_request: {},
      pedidos: [],
      options: [
        {
          value: null,
          text: "Seleccione validacion de credencial"
        },
        {
          value: 1,
          text: "Mediante codigo"
        },
        {
          value: 2,
          text: "Mediante QR"
        }
      ]
    };
  },
  methods: {
    setData: function(select) {
      console.log(select);
    },
    getRequest(user) {
      let exist = false;
      this.$store
        .dispatch("getRequestFromUser", user.id_user_primary)
        .then(response => {
          const products = this.$store.getters.cafeteriaRequestsExt.products;
          if(products.pedidos.length > 0 ){
            console.log('logs',products.pedidos)
            this.pedidos.push(products);
          }
        })
        .catch(error => {
          console.log("Error ", error);
        });
    },
    searchId: function() {
      console.log(this.idSearch);
      this.$store
        .dispatch("validateCredentialDispatch", this.idSearch)
        .then(response => {
          console.log("respuesta", response);
        })
        .catch(err => {
          console.log("respuesta", err);
        });
    },
    prepare_request: function(credential, request) {
      if (!this.aux_request[credential]) {
        this.aux_request[credential] = [];
      }
      this.pedidos.forEach(element => {
        if (element.code == credential) {
          element.pedidos.forEach(requ => {
            if (requ.id == request.id) {
              request.preparado = true;
            }
          });
        }
      });
      //this.aux_request[credential].push(request.id)
    },
    remove_item_request: function(credential, index) {
      this.pedidos[credential].pedidos[index].preparado = false;
    },
    remove_request: function(index) {
      this.$root.showInfoDialog(
        "Mensaje informativo",
        "Seguro que desea retirar esta entrega de la lista",
        "Si",
        () => {
          this.pedidos.splice(index, 1);
        },
        "No",
        null
      );
    },
    dispatch_request: function(index) {
      let request = [];
      let data = {};
      this.pedidos[index].pedidos.forEach(element => {
        if (element.preparado) {
          request.push(element.id);
        }
      });

      data = {
        pedidos: request
      };

      this.$store.dispatch("externalDispatchProduct", data).then(response => {
        this.pedidos.splice(index, 1);
      });
    },
    onDecode: function(decode) {
      let exist = false;
      let index = (this.show_qr = false);
      this.$store
        .dispatch("validateCredentialDispatch", decode)
        .then(response => {
          if (this.$store.getters.cafeteriaRequestsExt.user) {
            const user = this.$store.getters.cafeteriaRequestsExt.user;
            const data = {
              name: user.name,
              code: user.code,
              pedidos: user.pedidos
            }
          
            this.pedidos.push(user);
          
            console.log('logs',user)
            this.pedidos.forEach((element, i) => {
              if (element.code == user.code) {
                exist = true;
                index = i;
              }
            });
            if (exist) {
              //this.pedidos.splice(index, 1);
            }
            //this.getRequest(user);
          }
          
        });
    }
  }
};
</script>

<style>
#qr_entrega .qrcode-reader__camera {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/external/entrega/validate.vue